/**
 * Money Converter
 * Used in angular to format a number into a currency with given symbol, thousand and decimal place seperators
 */
angular.module('bookingApp')
.filter('money',['$filter', function($filter){
    var convertFilter = function(input, currencySymbol, thousandSeperator, decimalPoint){
        var currencySymbol = currencySymbol || "$";
        var thousandSeperator = thousandSeperator || ',';
        var decimalPoint = decimalPoint || '.';
        var convertedValue = $filter('currency')(input, currencySymbol);

        // replace with thousand seperators
        var decimalPointAt = convertedValue.indexOf('.'); // this will only be the one occurence
        convertedValue = convertedValue.replace(',',thousandSeperator);

        // replace the decimal point
        String.prototype.replaceAt=function(index, character) {
            return this.substr(0, index) + character + this.substr(index+character.length);
        };
        convertedValue = convertedValue.replaceAt(decimalPointAt,decimalPoint);

        return convertedValue;
    };
    return convertFilter;
}]);